var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{ref:"dropdownRef",staticClass:"dropdown-content",class:{ 'dropdown-above': _vm.showAbove }},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }